// extracted by mini-css-extract-plugin
export default {"container":"App_container__TXEoH","main":"App_main__Ouif1"};